
export default {
  0: "校招",
  1: "社招",
}